<template>
  <base-material-card class="v-card--material-chart" v-bind="$attrs" v-on="$listeners">
    <GChart
      :settings="{ packages: ['bar'] }"
      :data="processedChartData"
      :options="chartOptions"
      :createChart="createChart"
      @ready="onChartReady"
    />

    <slot />

    <slot slot="actions" name="actions" />
  </base-material-card>
</template>

<script>
import _ from 'lodash';
import moment from 'moment-timezone';

import colors from '@/utils/colors';
import { longDateFormat } from '@/utils/dates';

export default {
  name: 'MaterialBarChartCard',
  inheritAttrs: false,
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    showTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartLibrary: null,
    };
  },
  computed: {
    processedChartData() {
      if (!this.chartLibrary) return [];
      const theData = _.clone(this.chartData);
      const dataTable = new this.chartLibrary.visualization.DataTable();
      const headerRow = theData.shift() || [];
      dataTable.addColumn('date', headerRow.shift());
      if (_.isEmpty(headerRow)) {
        headerRow.push('Empty');
      }
      headerRow.forEach((value) => {
        dataTable.addColumn('number', value);
      });
      dataTable.addRows(
        theData.map((row) => {
          row[0] = moment(row[0], longDateFormat).toDate();
          return row;
        }),
      );

      return dataTable;
    },
    chartOptions() {
      if (!this.chartLibrary) return null;
      return this.chartLibrary.charts.Bar.convertOptions({
        backgroundColor: 'transparent',
        height: 370,
        isStacked: true,
        hAxis: {
          format: `MM/d/yy${this.showTime ? ' hh:mm a' : ''}`,
        },
        legend: { position: 'end', maxLines: 10 },
        series: {
          0: { color: colors[0] },
          1: { color: colors[1] },
          2: { color: colors[2] },
          3: { color: colors[3] },
          4: { color: colors[4] },
          5: { color: colors[5] },
          6: { color: colors[6] },
          7: { color: colors[7] },
          8: { color: colors[8] },
          9: { color: colors[9] },
          10: { color: colors[10] },
          11: { color: colors[11] },
        },
      });
    },
  },
  methods: {
    onChartReady(chart, google) {
      this.chartLibrary = google;
    },
    createChart(el, google) {
      return new google.charts.Bar(el);
    },
  },
};
</script>

<style lang="scss">
.v-card--material-chart {
  padding-top: 2em;
  .v-card--material__header {
    padding: 2em 0;
  }
}
</style>
